import React, { useEffect, useState } from 'react'
import "./loginPageStyle.scss"
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom'
import { SocketState } from '../context/SocketProvider'
import { useDispatch } from 'react-redux';
import { SET_MAIN_LOADER } from '../redux/loaderSlice';
import { SET_LOGIN_FORM_ERROR } from '../redux/errorMessageSlice';

/* ================= VALIDATION ================= */
const schema = yup.object().shape({
  user_name: yup.string().required('Username required'),
  password: yup.string().required('Password required'),
});

const defaultValues = {
  user_name: JSON.parse(localStorage.getItem('creditionlsDetails'))?.user_name || '',
  password: JSON.parse(localStorage.getItem('creditionlsDetails'))?.password || '',
};

function LoginPage() {
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const navigate = useNavigate();

  const [announcement, setAnnouncement] = useState(
    'Welcome to Laxmi Coupon'
  );

  /* ================= ANNOUNCEMENT ================= */
  useEffect(() => {
    if (!socket) return;

    socket.emit("req", {
      en: "GET_ANNOUCEMENT",
      data: {}
    });

    const handleRes = (res) => {
      if (res?.en === "GET_ANNOUCEMENT") {
        setAnnouncement(res.data?.annoucements || '');
      }
    };

    socket.on("res", handleRes);

    return () => {
      socket.off("res", handleRes); // ✅ SAFE cleanup
    };
  }, [socket]);

  const { control, handleSubmit } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });

  /* ================= SUBMIT ================= */
  function onSubmit({ user_name, password }) {
    dispatch(SET_LOGIN_FORM_ERROR(null))
    dispatch(SET_MAIN_LOADER(true))

    const payload = {
      en: "AppLunchDetails",
      data: { user_name, password }
    }

    localStorage.setItem(
      'creditionlsDetails',
      JSON.stringify({ user_name, password })
    );

    socket?.emit("req", payload)
  }

  return (
    <div className="laxmi-page">

      {/* TOP SCROLL BAR */}
      <div className="scroll-bar">
        <div className="scroll-text">
          {announcement}
        </div>
      </div>

      {/* LEFT IMAGE */}
      {/* <div className="laxmi-left">
        <img src="/images/Laxmi.jpg" alt="Laxmi" className="laxmi-img" />
      </div> */}

      {/* RIGHT LOGIN */}
      <div className="laxmi-right">
        <h1 className="title">GOLDEN<br />LOTTO</h1>

        <form onSubmit={handleSubmit(onSubmit)} className="login-form">

          <Controller
            name="user_name"
            control={control}
            render={({ field }) => (
              <input {...field} placeholder="Username" />
            )}
          />

          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <input type="password" {...field} placeholder="Password" />
            )}
          />

          <button className="login-btn" type="submit">
            Login
          </button>
        </form>

        <button className="btn pink" onClick={() => navigate('/result')}>
          4D chart
        </button>

        <button className="btn blue" onClick={() => navigate('/resultTitli')}>
          Titli Result
        </button>

        <button className="btn yellow" onClick={() => navigate('/result3d')}>
          3D Result
        </button>

        <button className="btn orange" onClick={() => navigate('/result2d')}>
          4D Result
        </button>
        
        <button className="btn orange" onClick={() => navigate('/resultPana')}>
          Pana Result
        </button>

      </div>
    </div>
  )
}

export default LoginPage;
